import Page from "src/components/layouts/Page";
import css from "./PrivacyPolicy.module.scss";

export default function PrivacyPolicy(params) {
    return (
        <Page>
            <article className={css["article"]}>
                <div>
                    <h3>Agreement</h3>
                    <p>
                        Protecting your private information is our priority.
                        This Privacy Policy applies to the Livecart websites and
                        apps, and governs data collection and usage. For the
                        purposes of this Privacy Policy, unless otherwise noted,
                        all references to Livecart include, and all
                        corresponding applications. By using the Livecart
                        websites and apps, you consent to the data practices
                        described in this Privacy Policy as it may be updated
                        from time to time.
                    </p>
                </div>
                <div>
                    <h3>Collection of Your Personal Information</h3>
                    <p>
                        Livecart may collect personally identifiable
                        information, which includes, but is not limited to, your
                        name, email address and phone number. If you purchase
                        Livecart’s products and services, we collect billing and
                        credit card information. This information is solely used
                        to complete the purchase transaction. Livecart may also
                        collect anonymous demographic information, which is not
                        unique to you, included but not limited to your age,
                        gender, and household income. All such demographic
                        information is anonymized so that you are never
                        identified by and through the information.
                        <br />
                        Information about your computer hardware and software
                        may be automatically collected by Livecart. This
                        information can include, but is not limited to: your IP
                        address, browser type, browser language, files accessed,
                        errors generated, time zone, operating system, domain
                        name, access times and referring website addresses. This
                        information is used for the operation of the service, to
                        maintain quality of the service, and to provide general
                        statistics regarding use of the Livecart websites and
                        apps.
                    </p>
                </div>
                <div>
                    <h3> Blogs and Forums</h3>
                    <p>
                        Livecart provides the capacity for users to post
                        information in blogs and forums for sharing information
                        in a public space on the Livecart websites and apps.
                        This information is publicly available to all users of
                        these forums and visitors to our websites and apps.
                        Livecart encourages users to be cautious in disclosure
                        of personal information in any public forums as Livecart
                        is not responsible for the personal information users
                        elect to disclose.
                        <br />
                        Livecart supports third party widgets such as Facebook
                        and Twitter buttons on the Livecart websites and apps
                        that allow users to share information on different
                        platforms. These widgets may collect your IP address,
                        pages you visit, and use cookies to enable widgets to
                        function properly. Livecart is not responsible for your
                        interactions with these widgets as they are governed by
                        the privacy policy of the company providing them.
                        <br />
                        Please keep in mind that if you directly disclose
                        identifiable information or personally sensitive data
                        through Livecart’s public message boards, this
                        information may be collected and used by others.
                    </p>
                </div>

                <div>
                    <h3> Links from Livecart Websites and Apps</h3>
                    <p>
                        Some pages of the Livecart websites and apps may contain
                        external links. Livecart encourages you to review the
                        privacy statements of websites and apps you choose to
                        link to from Livecart so that you can understand how
                        those websites and apps collect, use and share your
                        information. Livecart is not responsible for the privacy
                        statements or other content on websites and apps outside
                        of websites and apps directly owned by Livecart.
                        Livecart encourages you not to provide personal
                        information, without assuring yourselves of the Privacy
                        Policy Statement of other websites and apps.
                    </p>
                </div>

                <div>
                    <h3> Use of your Personal Information</h3>
                    <p>
                        Livecart collects and uses your personal information to
                        operate its websites and apps and deliver the services
                        Livecart’s clients have requested.
                        <br />
                        Livecart uses Google Analytics and/or other tracking
                        software or technologies for tracking user behavior to
                        improve the user experience.
                        <br />
                        Livecart may also use your personally identifiable
                        information to inform you of other products or services
                        available from Livecart, its clients, and its
                        affiliates. Livecart may also contact you via surveys to
                        conduct research about your opinion of current services
                        or of potential new services that may be offered.
                        <br />
                        Livecart will not sell, rent, or lease customer or
                        website visitor information to third parties for any
                        purpose, unless explicit consent is received from you.
                        <br />
                        Livecart may, from time to time, contact you on behalf
                        of external business partners about a particular
                        offering that may be of interest to you. In those cases,
                        your unique personally identifiable information (email,
                        name, address, telephone number) is only transferred to
                        the third party upon your consent.
                        <br />
                        Livecart may share data and personal information with
                        our trusted third party partners, resellers, service
                        providers and business partners to help provide Livecart
                        Services. The purpose for which Livecart may disclose
                        your personal information or data to our trusted third
                        parties may include, but are not limited to, data
                        storage, database management, web analytics, payment
                        processing, statistical analysis, sending you email or
                        postal mail or providing customer support.
                        <br />
                        All such third parties are prohibited from using your
                        personal information except to provide these services to
                        Livecart, and they are required to maintain the
                        confidentiality and security of your personal
                        information and comply with this Privacy Policy.
                        <br />
                        Livecart may share generic aggregated demographic
                        information not linked to any personal information
                        regarding visitors and users with our business partners,
                        advertisers, and other affiliated third parties.
                        <br />
                        Usage details such as time, frequency, duration and
                        pattern of use, features used and the amount of storage
                        used will be recorded by Livecart in order to enhance
                        user experience of the Livecart websites, apps and
                        services and to help provide users the best possible
                        service.
                        <br />
                        Livecart may keep track of the websites, apps and pages
                        our users visit, in order to determine what Livecart
                        services are the most popular. This data may be used to
                        deliver customized content and advertising to customers
                        whose behavior indicates that they are interested in a
                        particular subject area.
                        <br />
                        Livecart will disclose your personal information,
                        without notice, only if required to do so by law or in
                        the good faith belief that such action is necessary to:
                        (a) conform to the edicts of the law or comply with
                        legal process served on Livecart; (b) protect and defend
                        the rights or property of Livecart; (c) investigate any
                        suspected illegal activity or potential violation of the
                        Livecart Services terms and conditions and, (d) act
                        under exigent circumstances to protect the personal
                        safety of users of Livecart, or the public.
                    </p>
                </div>

                <div>
                    <h3> User Account Contents</h3>
                    <p>
                        Livecart stores and maintains files, documents, emails
                        and other data stored in your user account. In order to
                        prevent loss of data due to errors or system failures,
                        Livecart keeps backup copies of data including the
                        contents of your user account. Files and data may remain
                        on our servers after user account deletion or
                        termination. Livecart may retain any customer data,
                        personal information and any other data as necessary to
                        comply with legal obligations, resolve disputes, and
                        enforce company rights. Livecart assures the contents of
                        user accounts will not be disclosed to anyone and will
                        not be accessible to Livecart employees except in
                        circumstances specifically mentioned in this Privacy
                        Policy. Livecart does not scan the contents of user
                        accounts for serving targeted advertisements.
                    </p>
                </div>

                <div>
                    <h3>Use of Cookies</h3>
                    <p>
                        The Livecart affiliated websites and apps may use
                        temporary and permanent “cookies” to help you
                        personalize and enhance your online experience of
                        Livecart Services. A cookie is a text file that is
                        placed on your hard disk by a web page server. Cookies
                        cannot be used to run programs or deliver viruses to
                        your computer. Cookies are uniquely assigned to you, and
                        can only be read by a web server in the domain that
                        issued the cookie to you.
                        <br />
                        One of the primary purposes of cookies is to provide a
                        convenience feature to save you time. The purpose of a
                        cookie is to tell the Web server that you have returned
                        to a specific page. For example, if you personalize
                        Livecart pages, or register with Livecart site or
                        services, a cookie helps Livecart to recall your
                        specific information on subsequent visits. This
                        simplifies the process of recording your personal
                        information, such as billing addresses, shipping
                        addresses, and so on. When you return to the same
                        Livecart website or app, the information you previously
                        provided can be retrieved, so you can easily use the
                        Livecart features that you customized.
                        <br />
                        Temporary cookies will be removed from your computer
                        each time you close your browser. The Livecart
                        affiliated websites and apps may store a permanent
                        cookie in your computer or mobile device so that you
                        will not be required to sign-in by providing complete
                        login information each time you return to our websites
                        or apps.
                        <br />
                        You have the ability to accept or decline cookies. Most
                        Web browsers automatically accept cookies, but you can
                        usually modify your browser setting to decline cookies
                        if you prefer. If you choose to decline cookies, you may
                        not be able to fully experience the interactive features
                        of the Livecart Services or websites and apps you visit.
                        Livecart ties cookie information to your email address
                        when you elect to remain logged in so as to maintain and
                        recall your preferences within the website or app.
                        <br />
                        Technologies such as cookies, beacons, tags and scripts
                        are used by Livecart and our third party partners,
                        affiliates, and/or service providers to analyze trends,
                        administer the websites and/or apps, track users’
                        movements around the sites, provide advertising based
                        upon browsing activities and interests and to gather
                        demographic information about our user base as a whole.
                        Livecart and third parties with whom we partner to
                        provide certain features on our websites and apps or to
                        display advertising based upon your Web browsing
                        activity use Local Storage Objects (LSOs) such as HTML5
                        to collect and store content information and
                        preferences. Various browsers may offer their own
                        management tools for removing HTML5 LSOs.
                    </p>
                </div>

                <div>
                    <h3>Security of your Personal Information</h3>
                    <p>
                        Livecart uses industry appropriate data collection,
                        storage and processing practices and security measures,
                        as well as physical security measures to protect against
                        unauthorized access, alteration, disclosure or
                        destruction of your personal information, username,
                        password, transaction information and data stored in
                        your user account. Access to your name and email address
                        is restricted to Livecart employees who need to know
                        such information in connection with providing Livecart
                        Services to you and are bound by confidentiality
                        obligations.
                        <br />
                        To secure your personal information from unauthorized
                        access, use or disclosure, Livecart uses strong
                        encryption systems.
                        <br />
                        When personal information (such as a credit card number)
                        is transmitted to other websites or apps, it is
                        protected through the use of encryption, such as a
                        Secure Sockets Layer (SSL) protocol.
                    </p>
                </div>

                <div>
                    <h3>Security of your Personal Information</h3>
                    <p>
                        Livecart uses industry appropriate data collection,
                        storage and processing practices and security measures,
                        as well as physical security measures to protect against
                        unauthorized access, alteration, disclosure or
                        destruction of your personal information, username,
                        password, transaction information and data stored in
                        your user account. Access to your name and email address
                        is restricted to Livecart employees who need to know
                        such information in connection with providing Livecart
                        Services to you and are bound by confidentiality
                        obligations.
                        <br />
                        To secure your personal information from unauthorized
                        access, use or disclosure, Livecart uses strong
                        encryption systems.
                        <br />
                        When personal information (such as a credit card number)
                        is transmitted to other websites or apps, it is
                        protected through the use of encryption, such as a
                        Secure Sockets Layer (SSL) protocol.
                    </p>
                </div>

                <div>
                    <h3>
                        Accessing, Updating and Removing Personal Information
                    </h3>
                    <p>
                        Upon request, Livecart will provide you with information
                        about whether we hold any of your personal information.
                        Users who wish to correct, update or remove any personal
                        information including those from a public forum,
                        directory or testimonial on our site may do so either by
                        accessing their user account or by contacting Livecart
                        Customer Support Services at support@livecart.ai. Such
                        changes may take up to 48 hours to take effect. We
                        respond to all enquiries within 30 days.
                    </p>
                </div>

                <div>
                    <h3>Children Under Thirteen</h3>
                    <p>
                        Livecart does not knowingly collect personally
                        identifiable information from children under the age of
                        thirteen. If you are under the age of thirteen, you must
                        ask your parent or guardian for permission to use this
                        website or app.
                    </p>
                </div>

                <div>
                    <h3>Federated Authentication</h3>
                    <p>
                        Users may be provided the ability to log in to Livecart
                        websites and apps using federated authentication
                        providers such as Facebook Connect. These services will
                        authenticate your identity and provide you the option to
                        share certain personal information with us such as your
                        name and email address to pre-populate our sign-up form.
                    </p>
                </div>

                <div>
                    <h3>
                        Disconnecting your Livecart Account from Third Party
                        Websites and Apps
                    </h3>
                    <p>
                        You may be able to connect your Livecart accounts to
                        third party accounts. BY CONNECTING YOUR LIVECART
                        ACCOUNTS TO YOUR THIRD PARTY ACCOUNT, YOU ACKNOWLEDGE
                        AND AGREE THAT YOU ARE CONSENTING TO THE CONTINUOUS
                        RELEASE OF INFORMATION ABOUT YOU TO OTHERS (IN
                        ACCORDANCE WITH YOUR PRIVACY SETTINGS ON THOSE THIRD
                        PARTY SITES). IF YOU DO NOT WANT INFORMATION ABOUT YOU,
                        INCLUDING PERSONALLY IDENTIFYING INFORMATION, TO BE
                        SHARED IN THIS MANNER, DO NOT USE THIS FEATURE.
                    </p>
                </div>

                <div>
                    <h3>Opt-Out & Unsubscribe</h3>
                    <p>
                        We respect your privacy and give you an opportunity to
                        opt-out of receiving announcements of certain
                        information. Users may opt-out of certain communications
                        from Livecart by selecting the ‘unsubscribe’ function
                        present in every email we send. Users will continue to
                        receive essential transactional emails.
                    </p>
                </div>

                <div>
                    <h3>Changes to this Privacy Policy</h3>
                    <p>
                        Livecart reserves the right, in its sole discretion, to
                        make changes to this Privacy Policy from time to time
                        with or without notice to reflect company and customer
                        feedback. Users will not receive notification of changes
                        to this Privacy Policy. Users are solely responsible for
                        checking for updates and periodically reviewing this
                        Privacy Policy to be informed of how Livecart is
                        protecting user information. Your continued use of
                        Livecart Services will be deemed to be your agreement to
                        the modified Privacy Policy.
                    </p>
                </div>

                <div>
                    <h3>Processor Disclosure</h3>
                    <p>
                        This certification covers our collection, use and
                        disclosure of information we collect through our
                        Livecart websites and apps and through Livecart
                        Services. The sole purpose of using collected
                        information is for the providing of Livecart Services to
                        its users. Livecart acknowledges that users have the
                        right to access their personal information. Livecart has
                        no direct relationship with the individuals whose
                        personal data it processes. Users can directly contact
                        support@livecart.ai to correct, amend, or delete
                        inaccurate data.
                        <br />
                        Livecart retains personal information processed on
                        behalf of customers for as long as needed to provide
                        Livecart Services to the customers. Livecart also
                        retains personal information for as long as necessary to
                        comply with our legal obligations, resolve disputes, and
                        enforce our agreements.
                        <br />
                        Livecart may transfer personal information to third
                        party service providers to help in providing Livecart
                        Services. Transfers to subsequent third parties are
                        covered by the provisions in this Privacy Policy
                        regarding notice and choice and the service agreements
                        with you.
                    </p>
                </div>

                <div>
                    <h3>Contact Information</h3>
                    <p>
                        Livecart makes every effort, including periodic reviews
                        to ensure that personal information provided by you is
                        used in conformity with this Privacy Policy. Livecart
                        welcomes your questions and comments regarding this
                        Privacy Policy. If you believe that Livecart has not
                        adhered to this Privacy Policy, please contact Livecart
                        at support@livecart.ai. We will contact you to address
                        your concerns, and we will cooperate with regulatory
                        authorities in this regard if needed.
                    </p>
                </div>
            </article>
        </Page>
    );
}
